const sessionExpiredModal = {
  title: "Lotan rann út",
  message: "Lotan þín rann út vegna aðgerðaleysis. Vinsamlegast skráðu þig inn aftur til að halda áfram.",
  redirectNotice: "Vísað á innskráningarsíðu eftir 5 sekúndur...",
  goToLogin: "Fara í innskráningu",
};

export default sessionExpiredModal;
